var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 48,
    rx: 21,
    fill: "#34C759"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 23.7081C45 29.0697 39.6274 33.4162 33 33.4162C32.6245 33.4162 32.2529 33.4022 31.8862 33.3749C30.3795 33.2627 28.8805 33.7293 27.5472 34.44V34.44C26.5621 34.9651 25.4991 35.0982 25.3208 34.9337C25.1425 34.7691 25.6792 34.3669 26.1698 33.7453V33.7453C26.8032 32.9427 26.3245 31.8254 25.4685 31.2665C22.7432 29.4868 21 26.7622 21 23.7081C21 18.3465 26.3726 14 33 14C39.6274 14 45 18.3465 45 23.7081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.2e0662c553f7d0e34178c18f2d48d1d2.svg";
export { ForwardRef as ReactComponent };